import { kReservedFieldNames, kReservedFieldNamesFR } from "../constants";

export function IsFieldNameReserved(fieldName) {
  var isReserved = false;
  if (fieldName != null) fieldName = fieldName.toLowerCase();

  var index = kReservedFieldNames.indexOf(fieldName);
  if (index != -1) isReserved = true;
  ///TODO: What.??????
  if (!isReserved) {
    var index = kReservedFieldNamesFR.indexOf(fieldName);
    if (index != -1) isReserved = true;
  }

  return isReserved;
}
